import { Flex } from '@mantine/core'
import styled from 'styled-components'
import { FundraisingSelectProps } from '.'

export const FundraisingSelectStyled = styled.div`
  .popover-icon {
    color: var(--color-text-3) !important;
  }
`

export const FundraisingSelectWrapStyled = styled(Flex)<Pick<FundraisingSelectProps, 'h'>>`
  gap: 4px;
  max-height: ${(h: any) => h};
  min-height: ${(h: any) => h};
  overflow-y: auto;
  padding-left: 8px;
  padding-right: 6px;
`

export const FundraisingSelectItemStyled = styled(Flex)`
  width: 100%;
  padding: 10px 32px 10px 8px;
  box-sizing: border-box;
  border-radius: 6px;
  justify-content: space-between;
  align-items: center;
  line-height: 120%;
  cursor: pointer;
  position: relative;

  .focus-icon {
    position: absolute;
    right: 8px;
  }

  &[data-focus='true'] {
    .focus-text {
      color: var(--color-brand-1);
    }
  }

  &:hover {
    background: var(--color-neutral-3);
  }
`
